import { render } from "./ManagerViewManagers.vue?vue&type=template&id=58d90b30"
import script from "./ManagerViewManagers.vue?vue&type=script&lang=js"
export * from "./ManagerViewManagers.vue?vue&type=script&lang=js"

import "./ManagerViewManagers.vue?vue&type=style&index=0&id=58d90b30&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__